(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-maker-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousels = (scope) => {
      const roots = scope.querySelectorAll('[data-review-carousel]:not([data-review-ready])');
      roots.forEach((root) => {
        root.setAttribute('data-review-ready', 'true');
        const track = root.querySelector('[data-review-track]');
        const slides = Array.from(root.querySelectorAll('[data-review-slide]'));
        const dots = Array.from(root.querySelectorAll('[data-review-goto]'));
        if (!track || slides.length < 2) return;

        slides.forEach((slide) => {
          slide.hidden = false;
        });

        let activeIndex = 0;
        let timer;
        const desktopLayout = window.matchMedia('(min-width: 990px)');
        const controls = root.querySelector('.codex-maker-reviews__controls');
        let visibleCount = Math.min(desktopLayout.matches ? 2 : 1, slides.length);
        const pageCount = () => Math.ceil(slides.length / visibleCount);
        const interval = Math.max(3000, Number(root.dataset.interval) || 5000);
        const shouldAutoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const stopTimer = () => {
          if (timer) window.clearInterval(timer);
          timer = undefined;
        };

        const syncTimer = () => {
          stopTimer();
          if (shouldAutoplay && !document.hidden && pageCount() > 1) {
            timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
          }
        };

        const showSlide = (requestedIndex) => {
          const pages = pageCount();
          activeIndex = ((requestedIndex % pages) + pages) % pages;
          const firstIndex = Math.min(activeIndex * visibleCount, slides.length - visibleCount);
          if (visibleCount === 1) {
            track.style.transform = `translateX(-${firstIndex * 100}%)`;
          } else {
            const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
            track.style.transform = `translateX(calc(-${firstIndex * 100 / visibleCount}% - ${firstIndex * gap / visibleCount}px))`;
          }
          slides.forEach((slide, index) => {
            const isActive = index >= firstIndex && index < firstIndex + visibleCount;
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });
          dots.forEach((dot, index) => {
            dot.hidden = index >= pages;
            const start = Math.min(index * visibleCount, slides.length - visibleCount);
            dot.setAttribute('aria-label', visibleCount === 1 ? `Go to review ${index + 1}` : `Go to reviews ${start + 1} and ${start + visibleCount}`);
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (controls) controls.hidden = pages < 2;
          syncTimer();
        };

        root.querySelector('[data-review-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
        root.querySelector('[data-review-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
        dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.reviewGoto))));
        document.addEventListener('visibilitychange', syncTimer);
        const updateLayout = () => {
          const firstIndex = Math.min(activeIndex * visibleCount, slides.length - visibleCount);
          visibleCount = Math.min(desktopLayout.matches ? 2 : 1, slides.length);
          showSlide(Math.floor(firstIndex / visibleCount));
        };
        if (desktopLayout.addEventListener) desktopLayout.addEventListener('change', updateLayout);
        else desktopLayout.addListener(updateLayout);
        root.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-review-slide]');
          if (selectedSlide) showSlide(Math.floor(Number(selectedSlide.dataset.reviewIndex) / visibleCount));
        });
        showSlide(0);
      });
    };

    const boot = () => initCarousels(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["codex-maker-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousels = (scope) => {
      const roots = scope.querySelectorAll('[data-codex-video-carousel]:not([data-video-carousel-ready])');
      roots.forEach((root) => {
        root.setAttribute('data-video-carousel-ready', 'true');
        const track = root.querySelector('[data-video-track]');
        const controls = root.querySelector('[data-video-controls]');
        const previous = root.querySelector('[data-video-prev]');
        const next = root.querySelector('[data-video-next]');
        const cards = Array.from(root.querySelectorAll('.codex-maker-videos__card'));
        if (!track || !controls || !previous || !next || cards.length < 2) return;

        let activeIndex = 0;
        const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
        const desktopLayout = window.matchMedia('(min-width: 750px)');

        const updateSlides = () => {
          const previousIndex = (activeIndex - 1 + cards.length) % cards.length;
          const nextIndex = (activeIndex + 1) % cards.length;
          const isDesktop = desktopLayout.matches;

          cards.forEach((card, index) => {
            const isActive = index === activeIndex;
            const isPrevious = index === previousIndex;
            const isNext = index === nextIndex;
            const isAccessible = isDesktop || isActive;
            card.classList.toggle('is-active', isActive);
            card.classList.toggle('is-prev', !isActive && isPrevious);
            card.classList.toggle('is-next', !isActive && isNext);
            card.setAttribute('aria-hidden', isAccessible ? 'false' : 'true');
            if (!inDesignMode) card.inert = !isAccessible;

            card.querySelectorAll('video').forEach((video) => {
              if (!isDesktop && !isActive) {
                video.pause();
              }
            });
          });

          controls.hidden = cards.length < 2 || isDesktop;
          previous.disabled = false;
          next.disabled = false;
        };

        const rotate = (direction) => {
          activeIndex = (activeIndex + direction + cards.length) % cards.length;
          updateSlides();
        };

        cards.forEach((card) => {
          const video = card.querySelector('video');
          const playButton = card.querySelector('[data-video-play]');
if (!video || !playButton) return;
let loadingIndicator = card.querySelector('[data-video-loading]');
if (!loadingIndicator) {
  loadingIndicator = document.createElement('div');
  loadingIndicator.className = 'codex-maker-videos__loading';
  loadingIndicator.setAttribute('data-video-loading', '');
  loadingIndicator.setAttribute('role', 'status');
  loadingIndicator.setAttribute('aria-live', 'polite');
  loadingIndicator.innerHTML = '<span class="codex-maker-videos__loading-paw" aria-hidden="true">🐾</span><span class="codex-maker-videos__loading-label">Loading…</span>';
  loadingIndicator.hidden = true;
  card.querySelector('.codex-maker-videos__media').appendChild(loadingIndicator);
}
const setLoading = (isLoading) => { loadingIndicator.hidden = !isLoading; }; const isMobileVideo = window.matchMedia('(max-width: 749px)').matches; video.controls = !isMobileVideo;
          const syncPlayButton = () => {
playButton.hidden = !video.paused; playButton.setAttribute('aria-label', video.paused ? 'Play project video' : 'Pause project video'); playButton.innerHTML = video.paused ? '<svg viewBox="0 0 24 24"><path d="M8 5.8v12.4c0 .9 1 1.3 1.7.8l9-6.2a1 1 0 0 0 0-1.6l-9-6.2c-.7-.5-1.7-.1-1.7.8Z" fill="currentColor"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"/></svg>';           };

          playButton.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            try {
if (video.paused) { setLoading(true); await video.play(); } else { setLoading(false); video.pause(); }            } catch (error) {
syncPlayButton();            }
          });

          video.addEventListener('play', syncPlayButton);
          video.addEventListener('pause', syncPlayButton);
          video.addEventListener('ended', syncPlayButton);
video.addEventListener('waiting', () => setLoading(!video.paused));
video.addEventListener('stalled', () => setLoading(!video.paused));
video.addEventListener('playing', () => setLoading(false));

video.addEventListener('pause', () => setLoading(false));
video.addEventListener('error', () => setLoading(false));
video.addEventListener('click', () => { if (video.paused) { setLoading(true); video.play().catch(() => setLoading(false)); } else { setLoading(false); video.pause(); } });
          syncPlayButton();
        });

        previous.addEventListener('click', () => rotate(-1));
        next.addEventListener('click', () => rotate(1));
        if (desktopLayout.addEventListener) desktopLayout.addEventListener('change', updateSlides);
        else desktopLayout.addListener(updateSlides);
        updateSlides();
      });
    };

    const boot = () => initCarousels(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-mobile-footer')) {
    customElements.define('ff-mobile-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.triggers = Array.from(this.querySelectorAll('[data-ff-footer-toggle]'));
        this.setExpanded = (trigger, expanded) => {
          const panel = trigger.nextElementSibling;
          trigger.parentElement.classList.toggle('open', expanded);
          trigger.setAttribute('aria-expanded', String(expanded));
          panel.inert = !expanded;
          panel.style.height = expanded ? panel.scrollHeight + 'px' : '0px';
        };
        this.sync = () => {
          this.triggers.forEach((trigger, index) => {
            const panel = trigger.nextElementSibling;
            panel.id ||= this.id + '-panel-' + index;
            if (this.mobile.matches) {
              trigger.setAttribute('role', 'button');
              trigger.tabIndex = 0;
              trigger.setAttribute('aria-controls', panel.id);
              this.setExpanded(trigger, false);
            } else {
              trigger.removeAttribute('role');
              trigger.removeAttribute('tabindex');
              trigger.removeAttribute('aria-expanded');
              trigger.removeAttribute('aria-controls');
              trigger.parentElement.classList.remove('open');
              panel.inert = false;
              panel.style.height = '';
            }
          });
        };
        this.toggle = (trigger) => {
          const expanded = trigger.getAttribute('aria-expanded') !== 'true';
          this.triggers.forEach((item) => this.setExpanded(item, item === trigger && expanded));
        };
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-ff-footer-toggle]');
          if (!trigger || !this.contains(trigger) || !this.mobile.matches) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.toggle(trigger);
        }, { capture: true, signal: this.controller.signal });
        this.addEventListener('keydown', (event) => {
          const trigger = event.target.closest('[data-ff-footer-toggle]');
          if (!trigger || !this.mobile.matches || !['Enter', ' '].includes(event.key)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.toggle(trigger);
        }, { capture: true, signal: this.controller.signal });
        this.mobile.addEventListener('change', this.sync, { signal: this.controller.signal });
        window.addEventListener('resize', () => {
          if (!this.mobile.matches) return;
          this.triggers.forEach((trigger) => {
            if (trigger.getAttribute('aria-expanded') === 'true') {
              const panel = trigger.nextElementSibling;
              panel.style.height = 'auto';
              panel.style.height = panel.scrollHeight + 'px';
            }
          });
        }, { signal: this.controller.signal });
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
